import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import Slider from "./modules/site-nav";
Slider().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

import Counter from "./modules/counter";
Counter().init()

import Accordions from "./modules/accordions";
Accordions().init()

import LogoGallery from "./modules/logo-gallery";
LogoGallery().init()

import AwardsGallery from "./modules/awards";
AwardsGallery().init()

import ServicesGallery from "./modules/services";
ServicesGallery().init()

import VideoReview from "./modules/video-review";
VideoReview().init()

// Templates

// Template parts

// Pages
